// extracted by mini-css-extract-plugin
export default {"app":"App_app__aR6zO","content":"App_content__4XS1E"};